import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { Category } from '../models/category.model';
import { I18nService } from '../services/i18n.service';

@Pipe({
  name: 'categoryName',
  standalone: true,
  pure: false
})
export class CategoryNamePipe implements PipeTransform {
  private sub?: Subscription;

  constructor(private i18n: I18nService, private cdr: ChangeDetectorRef) {
    this.sub = this.i18n.language$.subscribe(() => this.cdr.markForCheck());
  }

  /**
   * @param value Category entity, or legacy plain name string.
   * @param nameEn optional when value is a string (e.g. product.categoryNameEn from API).
   * @param nameAr optional when value is a string.
   */
  transform(
    value: string | Category | null | undefined,
    nameEn?: string | null,
    nameAr?: string | null
  ): string {
    if (this.isCategory(value)) {
      return this.i18n.localizeCategoryName(value.name ?? '', value.nameEn, value.nameAr);
    }
    return this.i18n.localizeCategoryName((value as string) ?? '', nameEn, nameAr);
  }

  private isCategory(value: unknown): value is Category {
    return (
      typeof value === 'object' &&
      value !== null &&
      'id' in value &&
      'name' in value
    );
  }
}
